import React from 'react';
import CookieBanner from 'react-cookie-banner';
import B from 'bem-cn';

import './index.scss';

const cl = B('BottomBar');

export default function BottomBar() {
  return (
    <CookieBanner
      message="We use cookies to enhance your experience. By continuing to browse this site you agree to our use of cookies."
      cookie="kng_cookiebar"
      buttonMessage="Ok"
      dismissOnScrollThreshold={100}
      cookieExpiration={0}
      className={cl()}
      disableStyle={true}
    />
  );
}



// WEBPACK FOOTER //
// ../src/components/bottomBar/index.jsx